import BillingAddressFormV2 from './billing-address-form-v2';

export default BillingAddressFormV2;
